import _ from 'lodash';
import * as types from '@/store/types';
import { lsErrorService } from 'ls-vue-common';
// eslint-disable-next-line import/no-cycle
import lsTrackService from '@/services/ls-track/ls-track.service';

export const state = {
    changeAddress: {
        name: 'changeAddress',
        show: false,
    },
    faq: {
        name: 'faq',
        show: false,
    },
    howQuotingWorks: {
        name: 'howQuotingWorks',
        show: false,
    },
    lawnTreatment: {
        name: 'lawnTreatment',
        show: false,
    },
    longGrass: {
        name: 'longGrass',
        show: false,
    },
    oneTimeMowingNotAvailable: {
        name: 'oneTimeMowingNotAvailable',
        show: false,
    },
    termsOfService: {
        name: 'termsOfService',
        show: false,
    },
    threeCutMinimum: {
        name: 'threeCutMinimum',
        show: false,
    },
    whyLawnTreatment: {
        name: 'whyLawnTreatment',
        show: false,
    },
    reschedule48: {
        name: 'reschedule48',
        show: false,
    },
};

export const mutations = {
    [types.MODAL__MUTATE_MODAL](localState, { name, show }) {
        const currentModal = localState[name];
        if (currentModal) {
            currentModal.show = show;
        }
    },
    [types.MODAL__MUTATE_ALL_MODALS](localState, payload) {
        _.forEach(localState, (modal) => {
            _.forEach(payload, (val, key) => {
                // eslint-disable-next-line no-param-reassign
                modal[key] = val;
            });
        });
    },
};

export const actions = {
    [types.MODAL__CLOSE_MODAL]({ commit }, name) {
        lsTrackService.track({
            type: 'click',
            target: `${name}-modal--close`,
        });
        try {
            if (_.get(window, 'document.body.classList.remove')) {
                // See comment in types.MODAL__OPEN_MODAL regarding the convoluted logic
                const previousScrollTop =
                    _.get(document, 'body.dataset.previousScrollTop') ||
                    _.get(document, 'body.parentNode.dataset.previousScrollTop');
                document.body.classList.remove('ls-modal-open');
                _.set(document, 'body.style.marginRight', 0);

                if (_.get(document, 'body.parentNode.classList.remove')) {
                    // required for ios scrolling last as most likely to throw
                    document.body.parentNode.classList.remove('ls-modal-open');
                }

                _.set(document, 'body.scrollTop', previousScrollTop);
                _.set(document, 'body.parentNode.scrollTop', previousScrollTop);
            }
        } catch (error) {
            lsErrorService.log({ error });
        }

        commit(types.MODAL__MUTATE_MODAL, { name, show: false });
    },
    [types.MODAL__OPEN_MODAL]({ commit }, name) {
        lsTrackService.track({
            type: 'click',
            target: `${name}-modal--open`,
        });

        try {
            if (_.get(window, 'document.body.classList.add')) {
                // What is going on with all this data set stuff you ask
                // We are getting scrollTop if it exists, saving it as a data element on body or HTML depending on browser
                // Then when modal is closed accessing this data attribute to put the view back at the previous scroll
                // The use of both parentNode and body is to have support across iOS and chrome
                // This is only an issue on tablets and smaller as it's an issue caused by having to set
                // position: fixed in our ls-modal-open class to prevent background scrolling on iOS specifically
                const windowDiff = window.innerWidth - document.documentElement.clientWidth;
                const scrollTop =
                    _.get(document, 'body.scrollTop') ||
                    _.get(document, 'body.parentNode.scrollTop') ||
                    0;
                document.body.classList.add('ls-modal-open');
                _.set(document, 'body.dataset.previousScrollTop', scrollTop);
                _.set(document, 'body.parentNode.dataset.previousScrollTop', scrollTop);
                if (windowDiff > 0) {
                    // only add margin if scrollbars were present
                    _.set(document, 'body.style.marginRight', `${windowDiff}px`);
                }

                if (_.get(document, 'body.parentNode.classList.remove')) {
                    // required for ios scrolling last as most likely to throw
                    document.body.parentNode.classList.add('ls-modal-open');
                }
            }
        } catch (error) {
            lsErrorService.log({ error });
        }

        commit(types.MODAL__MUTATE_MODAL, { name, show: true });
    },
    [types.MODAL__CLOSE_ALL_MODALS]({ commit }) {
        commit(types.MODAL__MUTATE_ALL_MODALS, { show: false });
    },
};

export const getters = {};
